import React from 'react';
import { useTheme } from '../../hooks/useTheme';

interface SectionLayoutProps {
  id: string;
  title: string;
  subtitle?: string;
  description?: string;
  children?: React.ReactNode;
  className?: string;
}

export const SectionLayout: React.FC<SectionLayoutProps> = ({
  id,
  title,
  subtitle,
  description,
  children,
  className = ''
}) => {
  const { getBackgroundClass, getTextClass } = useTheme();

  return (
    <section 
      id={id} 
      className={`py-20 px-4 ${getBackgroundClass('secondary')} ${className}`}
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className={`text-4xl md:text-5xl font-bold mb-6 ${getTextClass('primary')}`}>
            {title}
          </h2>
          {subtitle && (
            <p className={`text-xl md:text-2xl mb-8 ${getTextClass('accent')}`}>
              {subtitle}
            </p>
          )}
          {description && (
            <p className={`text-lg max-w-4xl mx-auto leading-relaxed ${getTextClass('secondary')}`}>
              {description}
            </p>
          )}
        </div>
        {children}
      </div>
    </section>
  );
};